import { combineReducers } from "redux";

import theme from "./themeReducer";
import layout from "./layoutReducer";
import sidebar from "./sidebarReducer";

import user from "./userReducer";
import admin from "./adminReducer";
import mobileOriginated from "./mobileOriginatedReducer";
import multiFactor from "./multiFactorReducer";
import results from "./resultsReducer";
import upSell from "./upSellReducer";
import templates from "./templateReducer";
import bidgely from "./bidgelyReducer";
import campaign from "./campaignReducer";
import ecsDashboard from "./ecsDashboardReducer";
import creditTransfer from "./creditTransferReducer";
import campaignOnOff from "./campaignOnOffReducer";
import { reducer as toastr } from "react-redux-toastr";
import { USER_DESIRED_PAGE } from "../constants";

const appReducers = combineReducers({
  user,
  admin,
  results,
  mobileOriginated,
  multiFactor,
  upSell,
  templates,
  sidebar,
  layout,
  theme,
  toastr,
  bidgely,
  campaign,
  ecsDashboard,
  creditTransfer,
  campaignOnOff,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    // Force reducers to reload from initialStates
    state = undefined;
    sessionStorage.removeItem(USER_DESIRED_PAGE);
  }

  return appReducers(state, action);
};

export default rootReducer;
